export const root = "r13jzwn5";
export const title = "t1s1advd";
export const wrapper = "wjxcxbh";
export const plans = "p1y80b9r";
export const threePlans = "ttggq8a";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");